import { SxProps, Theme } from '@mui/material';

export const tableCellTypographyOverflowStyles: SxProps<Theme> = [
    {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
];
